import { observer } from 'mobx-react-lite'
import { CalendarDropdown } from 'shared/ui'
import { useViewPageContext } from 'pages/surveys/pages/view/context/viewContext'
import styles from './styles.module.scss'

export const AnalyticsCalendar = observer(() => {
  const { calendarFilterStore } = useViewPageContext()

  return (
    <div className={styles.wrap}>
      <CalendarDropdown store={calendarFilterStore} triggerProps={{ size: 'small' }} />
    </div>
  )
})
